import { useCallback, useEffect, useRef } from 'react';

/**
 *  Source: https://usehooks-ts.com/react-hook/use-is-mounted
 *  In React, once a component instance is unmounted, it is deleted from memory and will never be mounted again. 
 *  That's why we don't define a state in a disassembled component. Changing the state in an unmounted component will result this error:
 * 
 * [ Warning: Can't perform a React state update on an unmounted component.
     This is a no-op, but it indicates a memory leak in your application.
     To fix, cancel all subscriptions and asynchronous tasks in a useEffect cleanup function.]
 */
export const useIsMounted = () => {
  const isMountedRef = useRef<boolean>(true);
  useEffect(() => {
    isMountedRef.current = true;
    return () => {
      isMountedRef.current = false;
    };
  }, []);
  return useCallback(() => isMountedRef.current, []);
};
